import { createApp, markRaw } from 'vue'
import App from './App.vue'
import router from './router'
import '@mdi/font/css/materialdesignicons.css'
import { permission } from 'code-library/store/directives/permission';

// vue-axios
import axios from 'axios'
import VueAxios from 'vue-axios'

// axios.defaults.baseURL = `${process.env.VUE_APP_APIPATH}`;

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'


// pinia
import { createPinia } from "pinia";
import axiosAPIStore from "code-library/store/axiosAPI.js";

const pinia = createPinia();

pinia.use(({ store }) => {
  store.$router = markRaw(router)
});

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
})

const app = createApp(App).use(router).use(vuetify).use(pinia).use(VueAxios, { $myHttp: axios });
app.directive('permission', permission);

app.provide('$myHttp', app.config.globalProperties.$myHttp);
app.mount('#app');


router.beforeEach(async (to, from, next) => {
  const axiosAPI = axiosAPIStore();
  const { getCookieByName, setCookieByName } = axiosAPI;

  if (to.name === "loginPage") {
    await init();
  }

  if (to.meta.requiresAuth) {
    const accessToken = getCookieByName('accessToken') || null;

    if (!accessToken) {
      setCookieByName('path', to.path)
      next('/login');
      return;
    }

    // 檢查 AccessToken 是否過期，true 是沒過期
    const notExpired = await checkValidAccessToken(accessToken);

    // 沒過期，註銷帳號不可進入
    if (notExpired && to.meta.logOutlogOutStatusCannotEnter) {

      const mainUserInfo = await getUserInfoDetail(accessToken);

      const isLogOut = await checkUserAccountIsDeleted(mainUserInfo.email);

      if (isLogOut) {
        // 註銷帳號，不可進入
        next('/login');
      } else {
        next();
      }

      return;
    }

    if (notExpired) {
      // 沒過期
      next();
    } else {
      // 過期
      setCookieByName('path', to.path);
      next('/login');
    }
  } else {
    next();
  }
});

async function init() {
  const axiosAPI = axiosAPIStore();
  const { getCookieByName } = axiosAPI;

  // 是否為 chrome 和 Revit
  const sourceIsRevit = window.chrome && window.chrome.webview ? true : false;
  const accessToken = getCookieByName("accessToken") || null;
  const refreshToken = getCookieByName("refreshToken") || null;

  // 是 chrome 和 Revit、沒 accessToken 和 沒 refreshToken，不往下執行
  if (sourceIsRevit || !accessToken || !refreshToken) return;

  // 檢查 AccessToken 是否過期，true 是沒過期
  const notExpired = await checkValidAccessToken(accessToken);

  if (notExpired) {
    await router.push("/account_information/home");
  }
}

// 檢查 AccessToken 是否過期，true 是沒過期
async function checkValidAccessToken(accessToken) {
  return await axios.get(`${process.env.VUE_APP_APIPATH_B}Token/CheckValidAccessToken?AccessToken=${accessToken}`).then((res) => {
    return res.data;
  }).catch((error) => {
    console.error(error, 'main checkAccessToken')
  })
}

// 檢查使用者帳號是否已註銷關閉，true 是已註銷帳號
async function checkUserAccountIsDeleted(userAccount) {
  return await axios.get(`${process.env.VUE_APP_APIPATH_B}BackendManagement/CheckUserAccountIsDeleted?UserAccount=${userAccount}`).then((res) => {
    return res.data;
  }).catch((error) => {
    console.error(error, 'main checkUserAccountIsDeleted')
  })
}

// 使用者基本資料查詢
async function getUserInfoDetail(accessToken) {
  return await axios.get(`${process.env.VUE_APP_APIPATH_B}UserInfo/GetUserInfoDetail`, {
    headers: {
      'Authorization': `Bearer ${accessToken}`
    }
  }).then((res) => {
    return res.data;
  }).catch((error) => {
    console.error(error, 'main getUserInfoDetail')
  })
}